import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-between" }
const _hoisted_2 = { class: "flex flex-wrap items-center gap-x-4 gap-y-2" }
const _hoisted_3 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_4 = { class: "truncate" }
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = { class: "mb-2 sm:mb-0" }
const _hoisted_7 = { class: "rounded border-gray-200 bg-gray-50 px-1.5 py-0.5 text-xs ring-1 ring-gray-300" }
const _hoisted_8 = { class: "flex items-center space-x-1 text-sm" }
const _hoisted_9 = {
  key: 0,
  class: "truncate"
}
const _hoisted_10 = {
  key: 1,
  class: "truncate"
}
const _hoisted_11 = {
  key: 2,
  class: "truncate"
}
const _hoisted_12 = { class: "flex items-center space-x-1 text-xs text-gray-600" }
const _hoisted_13 = { class: "flex items-center lg:justify-end" }
const _hoisted_14 = { class: "mt-2 text-sm text-gray-600" }

import { CallModel, CallStatus, CallType, Permission } from '@/types';
import { formatDateAsString, formatSecToTime } from '@/utils/datetime';
import { CalendarIcon, ClockIcon, PlayIcon, UserIcon } from '@heroicons/vue/solid';
import { computed, PropType } from 'vue';
import moment from 'moment';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactTimelineCallDetails',
  props: {
    call: {
        type: Object as PropType<CallModel>,
        required: true,
    },
    showViewButton: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;

const duration = computed(() => {
    return moment(props.call?.endedAt).diff(moment(props.call.answeredAt), 'seconds');
});

const sourceEvent = computed(() => (props.call.events?.length ? props.call.events[0] : null));

const destinationEvent = computed(() => {
    const events = props.call.events ?? [];
    if (!events.length) return null;

    if (props.call.type === CallType.INBOUND && props.call.status === CallStatus.ANSWERED) {
        return events.find((event) => event.status === props.call.status) ?? null;
    } else if (props.call.type === CallType.OUTBOUND) {
        return events[0];
    }
    return events[events.length - 1];
});

return (_ctx: any,_cache: any) => {
  const _component_UiActionButton = _resolveComponent("UiActionButton")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createBlock(_component_UiPanel, { class: "hover:bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(CalendarIcon), {
              class: "h-4 w-4",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatDateAsString)(__props.call.startedAt.toString(), 'DD/MM/YYYY')), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatDateAsString)(__props.call.startedAt.toString(), 'HH:mm:ss')), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`call.type.${__props.call.type}`)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(UserIcon), {
              class: "h-4 w-4",
              "aria-hidden": "true"
            }),
            (sourceEvent.value?.sourceUser)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(sourceEvent.value?.sourceUser?.name), 1))
              : (destinationEvent.value?.destinationUser)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(destinationEvent.value?.destinationUser?.name), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(ClockIcon), {
              class: "h-4 w-4",
              "aria-hidden": "true"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('call.list.duration')) + ": ", 1),
            _createElementVNode("span", null, _toDisplayString(__props.call.status == _unref(CallStatus).ANSWERED && __props.call.endedAt
                            ? _unref(formatSecToTime)(duration.value)
                            : '-'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (
                        __props.showViewButton && _ctx.$can(_unref(Permission).VIEW_CALL) && __props.call.status === 'ANSWERED'
                    )
            ? _withDirectives((_openBlock(), _createBlock(_component_UiActionButton, {
                key: 0,
                variant: "primary",
                to: {
                        name: 'ViewCallById',
                        params: {
                            id: __props.call.id,
                        },
                    }
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlayIcon), {
                    class: "h-7 w-7",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.actions.View')), 1)
                ]),
                _: 1
              }, 8, ["to"])), [
                [_directive_tippy, _ctx.$t('core.actions.View')]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_14, _toDisplayString(__props.call.summary?.summaryText ?? _ctx.$t('call.list.noSummary')), 1)
      ])
    ]),
    _: 1
  }))
}
}

})